<div [class]="style">
    <img src='{{params.icon}}' style="width:17px;height: 17px;" (click)="removeRow()"/>
    {{params.value}}
</div>
